import { render, staticRenderFns } from "./EditarOrdemEtapa.vue?vue&type=template&id=1c051b3e"
import script from "./EditarOrdemEtapa.vue?vue&type=script&lang=js"
export * from "./EditarOrdemEtapa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports